import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UsersService } from '../../core/customers/glotto-users.service';
import * as _ from 'lodash';
import * as moment from "moment";
import { GanalottodoUsersDashboardBean } from "../../core/customers/glotto-users-dashboard.model";
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'glotto-users-chart',
  templateUrl: 'glotto-users-chart.component.html',
  styleUrls: ['glotto-users-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlottoUsersChartComponent implements OnInit, AfterViewInit {

  glottoUsersCountData: any; // Sales Amount Char Dataset
  glottoUsersCountOptions: any; // Options for Sales Amount Charset
  errorSalesChart = false;
  salesChartErrorMessage = '';

  private isLoading: boolean = false;
  private startDate: Date;
  private endDate: Date;
  private queryDates: Date[] = [];

  constructor(private usersService: UsersService) {
    // to fill query dates on init, set current date -1
    const now = moment().subtract(1, 'days').toDate();
    this.startDate = now;
    this.endDate = now;
    this.queryDates = [now, now];
  }

  ngOnInit(): void {
    this.errorSalesChart = false;
  }

  ngAfterViewInit(): void {
    this.updateGlottoUsersDashboard();
  }

  invalidDateRange(): boolean {
    return _.isNil(this.queryDates[0]) ||
      _.isNil(this.queryDates[1]);
  }

  updateGlottoUsersDashboard(): void {
    this.isLoading = true;
    // get information from Sales Service
    this.usersService.getGanalottodoUsersDashboard(this.queryDates)
      .finally(() => this.isLoading = false)
      .subscribe(
        response => {
          this.startDate = this.queryDates[0];
          this.endDate = this.queryDates[1];
          this.errorSalesChart = false;
          // after get information from sales service, fill Charts
          this.fillCountUsersDashboardChart(response);
        },
        error => {
          console.error('error: ', error);
          this.errorSalesChart = true;
          this.salesChartErrorMessage = error;
        }
      );
  }

  fillCountUsersDashboardChart(glottoUsersDashboard: GanalottodoUsersDashboardBean) {
    // build chart
    this.glottoUsersCountData = {
      labels: ['Activados', 'Cuenta Openpay', 'Han comprado'],
      datasets: [
        {
          label: 'Usuarios: ',
          data: [glottoUsersDashboard.totalActivatedUsers,
          glottoUsersDashboard.totalProfiledUsers,
          glottoUsersDashboard.totalUsersWithWagers],
          backgroundColor: [
            "#FF6384",
            "#FFCE56",
            "#0A59FF"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#FFCE56",
            "#0A59FF"
          ]
        },
      ]
    };

    this.glottoUsersCountOptions = {
      title: {
        display: true,
        text: 'Usuarios Ganalottodo Registrados: ' + glottoUsersDashboard.totalRegisteredUsers,
        fontSize: 16
      },
      legend: {
        position: 'bottom'
      }
    };

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/glotto-users/glotto-users-chart.component.ts